import { render, staticRenderFns } from "./FaqTypeView.vue?vue&type=template&id=6e9a03c8&scoped=true&"
import script from "./FaqTypeView.vue?vue&type=script&lang=ts&"
export * from "./FaqTypeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9a03c8",
  null
  
)

export default component.exports